"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AutoCompleteInput_1 = __importDefault(require("../../AutoCompleteInput"));
var index_1 = __importDefault(require("./index"));
var AutocompleteFilterItem = /** @class */ (function (_super) {
    __extends(AutocompleteFilterItem, _super);
    function AutocompleteFilterItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validOperators = ["in", "like"];
        _this.onResetClick = function () {
            _this.setState({
                selectedValues: undefined,
            });
            _this.props.onChange(_this.props.id, undefined, _this.props.operator ? _this.props.operator : AutocompleteFilterItem.defaultOperator);
        };
        _this.onValueSelected = function (value) {
            _this.setState({
                selectedValues: value.id,
            });
            _this.props.onChange(_this.props.id, value.id, _this.props.operator ? _this.props.operator : AutocompleteFilterItem.defaultOperator);
        };
        _this.suggestionValue = function (value) {
            return value.name; /* eslint-disable-line @typescript-eslint/no-unsafe-return */
        };
        _this.renderSearchBar = function (withLabel) {
            if (withLabel === void 0) { withLabel = true; }
            var selectedValues = _this.state.selectedValues;
            var label = _this.props.label || _this.props.id;
            // tslint:disable-next-line:max-union-size
            var rawValue;
            var value;
            if (Array.isArray(selectedValues)) {
                rawValue = selectedValues[0] ? selectedValues[0] : undefined;
            }
            else if (selectedValues) {
                rawValue = selectedValues;
            }
            var suggestions = _this.props.values || [];
            if (rawValue && suggestions) {
                value = suggestions.find(function (suggestion) { return suggestion.id == rawValue; });
            }
            return (react_1.default.createElement("div", { className: "body" },
                withLabel && react_1.default.createElement("label", null, label),
                react_1.default.createElement("div", { className: "input_container" },
                    react_1.default.createElement(AutoCompleteInput_1.default, { onSelected: _this.onValueSelected, onDeleteSuggestionsClick: _this.onResetClick, suggestions: _this.props.values || [], searchSuggestions: _this.props.autocomplete, getSuggestionValue: _this.suggestionValue, showDeleteText: true, value: value }))));
        };
        _this.renderDropdownBody = function () {
            return _this.renderSearchBar(false);
        };
        _this.renderLabel = function () {
            return _this.renderSearchBar();
        };
        return _this;
    }
    AutocompleteFilterItem.defaultOperator = "in";
    return AutocompleteFilterItem;
}(index_1.default));
exports.default = AutocompleteFilterItem;
//# sourceMappingURL=AutocompleteFilterItem.js.map